import { Badge, type BadgeProps } from "@mantine/core"
import Link from "next/link"
import { useTranslation } from "react-i18next"
import type { TCity } from "@/types/common"
import { cityName, peopleURL } from "@/utils"
import { getFlagEmoji } from "@/utils/getFlagEmoji"

export function CityLink({ city, ...props }: { city: TCity } & BadgeProps) {
  const { i18n } = useTranslation()

  return (
    <Link onClick={(e) => e.stopPropagation()} href={`${peopleURL}?params={"where":{"city_id":"${city.id}"}}`}>
      <Badge
        size="md"
        radius="sm"
        color="gray.7"
        variant="outline"
        leftSection={getFlagEmoji(city.country_code)}
        {...props}
      >
        {cityName(city, i18n.language)}
      </Badge>
    </Link>
  )
}
